<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Mic" class="d-icon d-icon--mic" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M4.586 1.086A2 2 0 0 1 8 2.5V6a2 2 0 1 1-4 0V2.5a2 2 0 0 1 .586-1.414ZM6 1.5a1 1 0 0 0-1 1V6a1 1 0 0 0 2 0V2.5a1 1 0 0 0-1-1Zm-3.5 3A.5.5 0 0 1 3 5v1a3 3 0 1 0 6 0V5a.5.5 0 0 1 1 0v1a4 4 0 0 1-3.5 3.969V11H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5V9.969A4 4 0 0 1 2 6V5a.5.5 0 0 1 .5-.5Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMic',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
